import React from 'react';
import { Footer, FooterMobile, HeaderB2B, HeaderB2BMobile } from 'components';
import { Helmet } from 'react-helmet';
import Spotlight from 'components/article/Spotlight';
import Others from 'components/article/Other';

export default function Blog({ isMobile = false }) {
  const pageMeta = {
    title: 'Blog Electrum: Info Seputar Tren dan Inovasi Motor Listrik',
    description:
      'Jelajahi artikel tentang tren, gaya hidup, dan inovasi motor listrik di blog Electrum. Ikuti perkembangan terbaru industri EV.',
    keywords: 'electrum, blog, motor listrik, EV, inovasi, artikel',
  };

  return (
    <div>
      <Helmet>
        <title>{pageMeta?.title}</title>
        <meta name="title" content={pageMeta?.title} />
        <meta name="description" content={pageMeta?.description} />
        <meta name="keywords" content={pageMeta?.keywords} />
        <meta property="og:title" content={pageMeta?.title} />
        <meta property="og:description" content={pageMeta?.description} />
        <link rel="canonical" href="https://electrum.id/blog" />
      </Helmet>

      {isMobile ? <HeaderB2BMobile /> : <HeaderB2B />}

      {/* SPOTLIGHT */}
      <Spotlight title="Artikel Pilihan" category="blog" />

      {/* OTHER NEWS */}
      <Others title="Blog Kami" category="blog" />

      {isMobile ? <FooterMobile /> : <Footer />}
    </div>
  );
}
